import { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useStyles } from './CloseSession.styles';
import { Input, inputType } from '../../../../../atoms/input';
import dayjs from '../../../../../../../utils/dayjs';
import { commonActionCreators } from '../../../../../../../redux/modules/common';
import Podium from '../../../../../../icons/lotties/lottieIcons/Podium';

const CloseSession = ({
  nextAppointment,
  scratchpad,
  addScratchpadNotes,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const hasNextAppointment = nextAppointment && dayjs(nextAppointment.startTime).isSame(dayjs(), 'day');
  const [timerValue, setTimerValue] = useState(
    hasNextAppointment ? dayjs(nextAppointment.startTime).diff(dayjs(), 'second') : 0,
  );
  const nextAppointmentFetched = useRef(false);

  useEffect(() => {
    if (!nextAppointmentFetched.current) {
      dispatch(commonActionCreators.fetchNextAppointment(true));
      nextAppointmentFetched.current = true;
    }
  }, []);

  useEffect(() => {
    if (!nextAppointment || timerValue <= 0) return;

    const intervalId = setInterval(() => {
      setTimerValue(prev => prev - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [nextAppointment, timerValue]);

  return (
    <Box className={classes.container}>
      <Box className={classes.welcomeFrame}>
        <Box display="flex" flexDirection="column" flexGrow={1} flex={1} gap="4px">
          <p className={classes.sectionTitle}>
            Nice session!
          </p>
          <p className={classes.sectionSubtitle}>
            Let's keep it moving
          </p>
        </Box>
        <Podium className={classes.animatedIcon} />
      </Box>
      <Box className={classes.contentBox}>
        <p className={classes.aboutText}>
          Write down anything that you’d like help with and we'll add it to your notes.
        </p>
        <Input
          fullWidth
          variant={inputType.DEFAULT}
          placeholder='Add any notes here'
          multiline
          minRows={3}
          maxRows={3}
          value={scratchpad}
          onChange={event => addScratchpadNotes(event.target.value)}
          onKeyDown={event => {
            if (event.key === ' ') {
              event.stopPropagation();
            }
          }}
        />
      </Box>
    </Box>
  );
};
export { CloseSession };
